import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/FactureAchatARapprocher/';

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function create(facture) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', facture);
  return response;
}

export async function get(factureId) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: factureId } });
  return response;
}

export async function update(facture) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', facture);
  return response;
}

export async function brouillon2Facture(id) {
  const response = await HTTP.post(URL_BASE + 'Brouillon2FactureAsync', { id: id });
  return response;
}

export async function facture2Brouillon(id) {
  const response = await HTTP.post(URL_BASE + 'Facture2BrouillonAsync', { id: id });
  return response;
}

export async function generationPaiementSurFacture(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationPaiementAsync', params);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function updateFactureEnregistrer(facture) {
  const response = await HTTP.put(URL_BASE + 'UpdateFactureEnregistrerAsync', facture);
  return response;
}

export async function avoirTotal(input) {
  const response = await HTTP.post(URL_BASE + 'AvoirTotalAsync', input);
  return response;
}

export async function factureGeneration(params) {
  const response = await HTTP.post(URL_BASE + 'PFactureGenerationAsync', params);
  return response;
}

export async function factureGenerationFromEcheances(params) {
  const response = await HTTP.post(URL_BASE + 'CreateFactureAchatFromEcheancesAsync', params);
  return response;
}
